/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from "react";
import UpcomingEventsPresenter from "./UpcomingEventsPresenter";
import DTOUpcomingEvents from "./DTOUpcomingEvents";
import { useAppSelector } from "../../../../infra/hooks";
import { useTranslation } from "react-i18next";

function UpcomingEventsController() {
  const { t, i18n } = useTranslation();

  const [myEvents, setMyEvents] = useState([]);

  const isLoading = useAppSelector(
    (state) => state.upcomingEventsSlice.eventLoader
  );
  function eventsCallback(events: any) {
    setMyEvents(events);
  }

  return (
    <>
      <DTOUpcomingEvents setEvents={eventsCallback} />
      <UpcomingEventsPresenter
        events={myEvents}
        isLoading={isLoading}
        i18n={i18n}
        trans={t}
      />
    </>
  );
}

export default UpcomingEventsController;
